import clsx from "clsx";
import { Grid, Radio, Typography } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../../theme/palette";

import { View } from "../../View";
import { RouteLabel } from "../../Layers/RouteLabelLayer/RouteLabel";
import { useState } from "react";
import { PickupPopup } from "../../SearchBar/PickupPopup";

const useStyles = makeStyles({
  option: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  optionMessage: {
    flex: 1,
  },
  labelContainer: {
    width: "86px",
    display: "flex",
    justifyContent: "center",
  },
  labelGrid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "white",
    borderRadius: "4px",
    boxShadow: `0px 2px 3px ${palette.typography.black.high}`,
    minHeight: "30px",
  },
  spacing: {
    padding: "2px",
  },
});

export const PickupEditOptionsModalOption = ({
  option,
  checked,
  onOptionChange,
}) => {
  const styles = useStyles();
  const [anchorEl, setAnchorEl] = useState();
  const { optionConfig } = option;
  const { routeCodes: labelRouteCodes, popupLabels } = optionConfig;
  return (
    <Grid container className={styles.option}>
      <Radio
        checked={checked}
        onChange={() => onOptionChange(option)}
        value={option}
        inputProps={{
          "aria-label": option.message,
        }}
      />
      <Typography className={styles.optionMessage}>{option.message}</Typography>
      <View
        className={styles.labelContainer}
        onClick={(e) => {
          e.stopPropagation();
          const routesCount = Object.keys(popupLabels).length;
          setAnchorEl(!anchorEl && routesCount ? e.currentTarget : null);
        }}
      >
        <View>
          <Grid container className={styles.labelGrid}>
            {labelRouteCodes.length > 6 ? (
              <Grid
                item
                container
                xs
                className={clsx(styles.spacing)}
                direction={"row"}
              >
                <RouteLabel routeCode={"M"} />
              </Grid>
            ) : (
              labelRouteCodes.map((routeCode, index) => (
                <Grid
                  key={index}
                  item
                  container
                  xs={
                    labelRouteCodes.length >= 3
                      ? 4
                      : 12 / labelRouteCodes.length
                  }
                  className={clsx(styles.spacing)}
                  direction={"row"}
                >
                  <RouteLabel routeCode={routeCode} />
                </Grid>
              ))
            )}
          </Grid>
        </View>
      </View>
      <PickupPopup
        anchorEl={anchorEl}
        pickupConfig={optionConfig}
        onClose={() => setAnchorEl(null)}
      />
    </Grid>
  );
};
